import React, { useEffect, useState } from 'react'
import ProductCard from './ProductCard'

const ProductGrid = ({ section, products }) => {

    const [productList, setProductList] = useState([])

    useEffect(() => {
        if (products) {
            setProductList(products)
        }
    }, [products])

    return (
        <div className='product-section container mx-auto mt-5'>
            <h4 className='mb-4 fw-bold'>{section}</h4>
            <div className="row">
                {
                    productList.map((item, i) => {
                        return (
                            <div
                                key={i}
                                style={{
                                    minHeight: '450px',  // Ensure a minimum height for consistent sizing
                                    display: 'flex',      // Make sure the card fills its container properly
                                    flexDirection: 'column', // Stack the content vertically within the column
                                }}
                                className="col-lg-3 col-md-4 col-12 col-sm-6 mb-lg-4 mb-md-4 mb-4"
                            >
                                <ProductCard product={item} />
                            </div>
                        );
                    })
                }
            </div>
        </div>
    )
}

export default ProductGrid